import i18n from './i18n'

export const i18nReady = new Promise<void>((resolve) => {
  if (i18n.isInitialized) {
    resolve()
  } else {
    i18n.on('initialized', () => {
      resolve()
    })
  }
})
